import { render } from "./TheG01ContentCategory.vue?vue&type=template&id=42a081f7&scoped=true&ts=true"
import script from "./TheG01ContentCategory.vue?vue&type=script&lang=ts"
export * from "./TheG01ContentCategory.vue?vue&type=script&lang=ts"

import "./TheG01ContentCategory.vue?vue&type=style&index=0&id=42a081f7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a081f7"]])

export default __exports__